/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MiningRewardChartPointResponse } from './mining-reward-chart-point-response';


export interface MiningRewardChartResponse { 
    data: Array<MiningRewardChartPointResponse>;
}

